<template>
  <div>
    <b-modal
      id="availablecredits"
      size="lg"
      ref="availablecredits"
      body-class="bg-white"
      :title="title"
      :no-close-on-backdrop="true"
      :hide-footer="true"
      :lazy="true"
    >
      <!--  table for showing availabel credit details -->
      <div class="table-responsive mt-4">
        <table class="table table-hover">
          <thead>
            <th>CREDIT INFO</th>
            <th>DATE CREDITED</th>
            <th class="text-right">CREDIT AMOUNT</th>
            <th></th>
          </thead>
          <tbody>
            <template v-if="items.length == 0">
              <tr>
                <td colspan="4" class="text-center">No credits to display</td>
              </tr>
            </template>
            <template v-else>
              <tr v-for="(item,index) in items" :key="index">
                <td>{{ item.credit_info }}</td>
                <td>{{ getDateFormat(item.date_created) }}</td>
                <td
                  class="text-right"
                >{{ currency + parseFloat(item.amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>

                <td class="text-right">
                  <b-button
                    variant="light"
                    size="sm"
                    class="mb-xs mr-xs"
                    v-on:click.stop="callavailableinvoicemodal(item)"
                  >Apply To Invoice</b-button>
                </td>
              </tr>
            </template>
          </tbody>
          <template v-if="items.length > 0">
            <tfoot>
              <tr>
                <td
                  colspan="3"
                  class="text-right"
                  style="border-top:none"
                >{{currency+ parseFloat(field.crdt_total_amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
              </tr>
            </tfoot>
          </template>
        </table>
      </div>
    </b-modal>
    <InvoiceAvailable
      :field="creditListDetails"
      :title="'Apply Credits from '+creditListDetails.credit_info"
      page="credit"
      :currency="getDetails(
                    $AppDetails.currency_details,
                    list.main_detail.cus_currency,
                    'currency_symbol'
                    )"
    ></InvoiceAvailable>
  </div>
</template>
<script>
import { mapState } from "vuex";
import store from "@/store/index";
import { notificationMixin } from "@/mixins/notification";
import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component
import InvoiceAvailable from "@/components/Modal/Customer/InvoiceAvailable"; // credits available modal\

export default {
  props: ["field", "title", "currency"], // field data form parent component
  mixins: [notificationMixin], // for showing message notification
  components: {
    InvoiceAvailable
  },
  data() {
    return {
      creditListDetails: {},
      items: [], // credit available details
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center" // class for notification message design
    };
  },
  methods: {
    // call avialbel modal
    async callavailableinvoicemodal(items) {
      this.creditListDetails = {
        crdt_id: items.id,
        id: this.$route.params.id,
        unused_amount: items.amount,
        apply_unused_amount: items.amount,
        credit_info: items.credit_info,
        type: items.type,
        place_of_supply: items.place_of_supply,
        pymnt_type: items.pymnt_type
      };
      await this.$root.$emit("bv::show::modal", "availableinvoice");
      await EventBus.$emit("emittedFieldData", this.creditListDetails);
      await EventBus.$emit("invoicecreditsincustomerdetails");
    },
    creditdetails() {
      store
        .dispatch(
          "customer/postUnusedcreditview",
          JSON.stringify({ id: this.$route.params.id })
        )
        .then(() => {
          this.items = this.credit_details;
        });
    }
  },
  mounted() {
    EventBus.$on("creditdetails", this.creditdetails); // to trigger the method from parentcomponent
  },
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    ...mapState({
      credit_details: state => state.customer.creditlist,
      list: state => state.customer.listView
    })
  }
};
</script>
<style>
.required:after {
  color: #e32;
  content: " *";
  display: inline;
}
</style>